import { useEffect, useState } from "react";
import axios from "axios";

const ConstantUseFetchImageUrls = (query) => {
  const [imageUrls, setImageUrls] = useState({});
  const [error, setError] = useState(null);
  const baseUrl =
    "https://atci.abcuniversity.accenture.com/abc-university-apis";
  // const baseUrl = "http://localhost:4004";
  useEffect(() => {
    const fetchImageUrls = async () => {
      try {
        const response = await axios.get(`${baseUrl}/images?${query}`, {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        });
        setImageUrls(response.data);
      } catch (err) {
        console.error("Error fetching image URLs:", err);
        setError(err);
      }
    };

    if (query) {
      fetchImageUrls();
    }
  }, [query]);

  return { imageUrls, error };
};

export default ConstantUseFetchImageUrls;
